import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const OfficeIcon = ({
  width = 24,
  height = 24,
  stroke = '#A0A4A8',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      d="M2.98815 9.73923L12.0001 3.43143L21.012 9.73923C21.3002 9.94066 21.6934 9.86478 21.8899 9.56942C22.0867 9.27375 22.0124 8.87089 21.7243 8.66945L12.3559 2.11268C12.1413 1.96244 11.8587 1.96244 11.644 2.11268L2.27568 8.66945C1.98757 8.87088 1.91326 9.27373 2.11004 9.56942C2.30653 9.86478 2.70002 9.94066 2.98815 9.73923Z"
      fill="#52575C"
    />
    <path
      d="M22 21.3527C22 20.995 21.7172 20.705 21.3685 20.705H19.5702V15.8129C19.5702 15.4552 19.2874 15.1656 18.9385 15.1656H13.5353C13.1864 15.1656 12.9038 15.4552 12.9038 15.8129V20.705H11.0964V15.8129C11.0964 15.4552 10.8139 15.1656 10.465 15.1656H5.06177C4.71286 15.1656 4.43003 15.4552 4.43003 15.8129V20.705H2.6317C2.28308 20.705 2.00024 20.995 2.00024 21.3527C2.00024 21.7101 2.28308 22 2.6317 22H21.3684C21.717 22 22 21.7101 22 21.3527ZM5.69338 20.7053V16.4603H9.83365V20.705L5.69338 20.7053ZM14.167 20.7053V16.4603H18.3073V20.705L14.167 20.7053Z"
      fill="#52575C"
    />
    <path
      d="M14.7017 13.8706C15.0503 13.8706 15.3331 13.5807 15.3331 13.223V7.68391C15.3331 7.32621 15.0503 7.03657 14.7017 7.03657H9.2982C8.94958 7.03657 8.66675 7.32621 8.66675 7.68391V13.223C8.66675 13.5807 8.94958 13.8706 9.2982 13.8706H14.7017ZM9.92992 8.33123H14.0702V12.5756H9.92992V8.33123Z"
      fill="#52575C"
    />
    <path
      d="M2.98815 9.73923L12.0001 3.43143L21.012 9.73923C21.3002 9.94066 21.6934 9.86478 21.8899 9.56942C22.0867 9.27375 22.0124 8.87089 21.7243 8.66945L12.3559 2.11268C12.1413 1.96244 11.8587 1.96244 11.644 2.11268L2.27568 8.66945C1.98757 8.87088 1.91326 9.27373 2.11004 9.56942C2.30653 9.86478 2.70002 9.94066 2.98815 9.73923Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
    <path
      d="M22 21.3527C22 20.995 21.7172 20.705 21.3685 20.705H19.5702V15.8129C19.5702 15.4552 19.2874 15.1656 18.9385 15.1656H13.5353C13.1864 15.1656 12.9038 15.4552 12.9038 15.8129V20.705H11.0964V15.8129C11.0964 15.4552 10.8139 15.1656 10.465 15.1656H5.06177C4.71286 15.1656 4.43003 15.4552 4.43003 15.8129V20.705H2.6317C2.28308 20.705 2.00024 20.995 2.00024 21.3527C2.00024 21.7101 2.28308 22 2.6317 22H21.3684C21.717 22 22 21.7101 22 21.3527ZM5.69338 20.7053V16.4603H9.83365V20.705L5.69338 20.7053ZM14.167 20.7053V16.4603H18.3073V20.705L14.167 20.7053Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
    <path
      d="M14.7017 13.8706C15.0503 13.8706 15.3331 13.5807 15.3331 13.223V7.68391C15.3331 7.32621 15.0503 7.03657 14.7017 7.03657H9.2982C8.94958 7.03657 8.66675 7.32621 8.66675 7.68391V13.223C8.66675 13.5807 8.94958 13.8706 9.2982 13.8706H14.7017ZM9.92992 8.33123H14.0702V12.5756H9.92992V8.33123Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  </svg>
);
